<template lang="pug">
		v-dialog(v-model="dialog" v-if="dialog" fullscreen hide-overlay transition="dialog-bottom-transition")
				template
						v-toolbar(dark dense color="red" class="navFixed")
								v-toolbar-title E-Waskat Preview 
								v-spacer
								v-toolbar-items
										v-btn(v-if="this.ip.ipStatus == 4 || this.ip.ipStatus == 8" @click="shareIP();" color="red" depressed title="Share" )
												v-icon share
												| &nbsp; Share
												v-dialog(v-model="share" persistent max-width="400px")
														v-card
																v-card-title(class="headline grey lighten-3") Share
																v-flex(class="headline grey lighten-3")
																		v-row(no-gutters align="center" justify="center")
																				ShareNetwork(
																						v-for="network in networks"
																						:key="network.key"
																						class="ma-3 pa-3 green"
																						:network="network.network"
																						style="border-radius: 10px; box-shadow: -2px 4px #888888;"
																						:url="shortenUrl"
																						:title="sharing.title"
																						:description="sharing.description"
																				) 
																						i(:class="network.icon" style="color:white")
																						span(class="ma-3" style="color:white") {{ network.name }}
																v-spacer
																v-flex(class="text-end headline grey lighten-2")
																		v-btn(color="blue darken-1" text @click.native="share = false") Close
										v-btn(@click="ip.ipStatus == 4 || ip.ipStatus == 8 ? print = true : printIP()" color="red" depressed title="Print" )
												v-icon print
												| &nbsp; Print
												v-dialog(v-model="print" persistent max-width="400px")
														v-card
																v-card-title(class="headline grey lighten-3") Print Document
																v-alert(:value='true' color="success")
																		h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
																v-flex(class="headline grey lighten-3")
																		v-row(no-gutters align="center" justify="center")
																				v-btn(@click="printIP(); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
																						i(class="far fah fa-lg fa fa-print" style="color:white")
																						span(class="ma-3" style="color:white") Print
																				v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
																						i(class="far fah fa-lg fa fa-share-alt" style="color:white")
																						span(class="ma-3" style="color:white") Share
																v-spacer
																v-flex(class="text-end headline grey lighten-2")
																		v-btn(color="blue darken-1" text @click.native="print = false") Close
										v-btn(@click.native="dialog = false" color="red" depressed)
												v-icon(title="Close") cancel
												| &nbsp; Close
						v-list(class="print-bg padTop60" style="height:100vh")
								div(:id="ip._id")
										.page(size="idCard")
												div(class="view-width" style="font-size:10px;")
														div(id="background")
															img(src="@/assets/bg_ewaskat.png" class="imgWatermark")
														table(class="view-width tableInput")
															tr
																td(class="align-center") 
																	img(class="verMiddle" src="@/assets/logo_cetak.png" height="25em")
															tr
																td(class="align-center")
																	div(style="display: block; background-color: black; color: #ffffff" class="font-weight-bold")
																		h1(style="font-size: 1.4em;") PEKERJA JANGKA PENDEK
															tr(style="height: 10em;")
																td(class="align-center d-flex justify-space-around" style="padding-top: 3px;")
																	img(v-if="ip.photoUrl" class="verMiddle image" :src="`${API_URL}/proxy-file/${this.$store.state.token}?url=${encodeURIComponent(ip.photoUrl)}`" style="width: 8em;" @load="onImgLoad")
															tr(style="vertical-align: top;")
																td(class="detail" style="padding-top: 3px;")
																	div(class="font-weight-bold")
																		h2(class="text-uppercase") {{ ip.ipKaryawan.name }}
																	div(class="ln-div") No. Waskat: 
																		b {{ ip.ipNo }}
																	div(class="ln-div" v-if="ip.ipKaryawan.position") {{ ip.ipKaryawan.position }}
																	div(class="ln-div" v-if="ip.ipKaryawan.department") {{ ip.ipKaryawan.department }}
																	div(class="ln-div font-weight-bold") {{ ip.ipKaryawan.company }}
																	div(class="ln-div" v-if="ip.ipWaskats.length > 0" v-for="(item, index) in ip.ipWaskats" :key="index")
																		div Pengawas {{ index + 1 }} :
																		div(class="font-weight-bold") {{ item.name }} / {{ item.nik }}
																	div(class="ln-div font-weight-bold")
																		span(class="align-center zona-kerja" style="background-color: green; color: #ffffff") Zona Kerja
																	div(class="ln-div font-weight-bold") 
																		span(class="align-center zona-kerja" style="color: green") {{ cleanZonaKerja.join(', ') }}
																	div(class="ln-div font-weight-bold") Mulai Pekerjaan : {{ formatDate((ip.ipExtendEstimateStart || ip.ipEstimateStart)) }}
																	div(class="ln-div font-weight-bold") Berlaku Sampai : {{ formatDate((ip.ipExtendEstimateEnd || ip.ipEstimateEnd)) }}
										.page(size="idCard")
												div(class="view-width" style="font-size:10px;")
														div(id="background")
															img(src="@/assets/bg_ewaskat.png" class="imgWatermark")
														table(class="view-width tableInput")
															tr
																td(class="align-center") 
																	img(class="verMiddle" src="@/assets/logo_cetak.png" height="25em")
															tr(style="height: 10em;")
																td(class="align-center d-flex justify-space-around" style="padding-top: 10px;")
																	img(class="verMiddle image-qr" :src="qrUrl")
															tr(style="vertical-align: top;")
																td(class="detail" style="padding-top: 10px;")
																	div(style="font-size: 6px")
																		h3 Syarat & Ketentuan
																		ol(type="number" style="padding-left: 15px; margin-top: 3px;")
																			li Pengawas 1 atau Pengawas 2 yang tercatat wajib melakukan pengawas melekat (WASKAT) kepada pekerja
																			li Memastikan JSA sudah disosialisasikan dan dipahami pekerja
																			li Kartu waskat hanya berlaku sesuai dengan foto dan nama yang tertera pada kartu
																			li Kartu hanya berlaku masksimal 14 Hari (Maksimal 1 kali perpanjangan)
																			li Wajib menggunakan APD selama bekerja di area operasional PT BIB
																	div(class="ln-div font-weight-bold text-center mt-2" v-if="ip.ipKaryawan.position") Kontak Darurat BIB 
																	div(class="ln-div font-weight-bold text-center" style="color: red") 081-2510-9555
</template>

<script>
import { mapState } from 'vuex';
import html2PDF from 'jspdf-html2canvas';
import moment from "moment-timezone";
export default {
	name: 'PrintEwaskatPDF',
	props: {
		ip: Object,
		approvalUser: Object,
		typeWaskat: String,
	},
	data: () => ({
		dialog: false,
		share: false,
		print: false
	}),
	computed: {
		...mapState(['API_URL', "networks", "sharing", "shortenUrl"]),
		locations(){
				let temp = []
				for (const index in this.ip.ipLocation) {
					temp.push(this.ip.ipLocation[index].name)
				}
				return temp
		},
		qrUrl() {
			let base = `${this.API_URL}/qr/generate/?ipNo=${this.ip.ipNo}&formCode=${this.ip.ipForm}`;
			if (this.typeWaskat === 'extendWaskat') {
				base += `&actionFor=extendWaskat`;
			}
			return base;
		},
		cleanZonaKerja() {
			return this.ip.ipZonaKerja.map(z => z.match(/Zona\s+\w+/)?.[0] ?? '')
		}
	},
	methods: {
		shareIP() {
			this.$store.dispatch("getShortenUrl", {ip: this.ip, 
			approvalUser: this.approvalUser, context: this.share}).then(() => {
				this.share = true;
			});
		},
		async printIP(){
			this.$store.state.loader = true;
			const pages = document.getElementsByClassName('page');
			await html2PDF(pages, {
				jsPDF: {
					orientation: 'p',
					unit: 'mm',
					format: [55, 90],
				},
				html2canvas: {
					useCORS: true,
					imageTimeout: 15000,
					scrollX: 0,
					scrollY: -window.scrollY,
					scale: 4,
				},
				imageQuality: 1,
				imageType: 'image/jpeg',
				success: async (pdf) => {
					await pdf.save(`${this.ip.ipNo}.pdf`);
				},
			});
			this.$store.state.loader = false;
		},
		formatDate(ipDate){
			if (!ipDate) return '-';
			return moment.tz(ipDate, 'Asia/Makassar').format('D MMMM YYYY');
		},
		approvalTime(date){
				return new Date(date).toLocaleString('en-GB');
		},
		onImgLoad () {
			setTimeout(() => this.$store.state.loader = false, 500);
		}
	},
	watch: {
		dialog (val) {
			this.$store.state.loader = false;
			if (val) setTimeout(() => this.$store.state.loader = true, 100);
		}
	}
};
</script>
<style scoped>
.ln-div{
	line-height: 11px;
}
.zona-kerja {
	width: 15em;
	display: block;
}
.print-bg {
	background: rgb(204,204,204);
	padding-top: 10px;
}
.print-bg > div{
	text-align:center;
}
.page {
	background: white;
	display: block;
	margin: 5px auto;
	padding: 0.3cm;
	position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
  margin:0 auto;
	display:inline-block;
	text-align:initial;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}
.page[size="idCard"] {
	width: 55mm;
	height: 89mm;
	margin:0 auto;
	text-align:initial;
	-webkit-print-color-adjust: exact;
	print-color-adjust: exact;
}
.view-width {
	width: 100%;
	height: 100%;
}
.logo-cell {
	padding:8px 5px 0px;
	width:35%;
}
.align-center {
	text-align: center;
}
.navFixed {
	position: fixed;
	z-index: 9;
}
.padTop60 {
	padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
	animation: blink 2s steps(5, start) infinite;
	color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
		
}
table {
	border-collapse: collapse;
	border: 3px solid #59c780;
	font-size: 0.79em;
}
.tableInput td{
		padding-left: 3px;
		padding-right: 3px;
}
.verMiddle{
		vertical-align:middle;
}
#background {
	position:absolute;
	z-index:0;
	display:block;
	top:23%;
	left:0px;
	text-align: center;
	width: 100%;
}
.imgWatermark {
  opacity: 0.15;
  width: 100%;
  padding: 5em 0.3cm;
}
.image {
	width: 10em;
	height: 10em;
	margin: 0.1em 0;
}
.image-qr {
	width: 15em;
	height: 15em;
	margin: 0.1em 0;
}
</style>
